import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  index: number
  total: number
}

const Counter = ({ index, total }: Props) => (
  <Box component="span" flexDirection="row" alignItems="center">
    ({index + 1}/{total})
  </Box>
)

export default observer(Counter)
